// src/components/spinner/Spinner.tsx
import React from 'react';
import './Spinner.scss';

interface SpinnerProps {
  size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 16 }) => {
  return (
    <div className="spinner" style={{ width: size, height: size }}>
      <div className="spinner-inner"></div>
    </div>
  );
};